import { on } from 'delegated-events'
import tingle from 'tingle.js'
import { handleValidation, handleBlur } from '../common/validation'
import IMask from 'imask'

const fn = {
  init: () => {
    on('blur', '.has-error', handleBlur, { capture: true })
    on('change', '.has-error', handleBlur, { capture: true })
    on('change', '.has-error blur', handleBlur, {
      capture: true,
    })
    on('keyup', 'textarea.has-length-limit', fn.handleLengthLimit, {
      capture: true,
    })
    on(
      'focus',
      '.styled-form-float input, .styled-form-float select',
      fn.handleStyledFocus,
      {
        capture: true,
      }
    )
    on(
      'blur',
      '.styled-form-float input, .styled-form-float select',
      (e) => fn.handleStyledBlur(e.target),
      {
        capture: true,
      }
    )
    on(
      'change',
      '.styled-form-float input, .styled-form-float select',
      (e) => fn.handleStyledBlur(e.target),
      {
        capture: true,
      }
    )
    on('submit', '[data-form-validate]:not(.multistepform)', (e) =>
      handleValidation(e.target)
    )
    on('submit', '[data-form-ajax]', fn.handleAjax)

    document
      .querySelectorAll('.styled-form-float input, .styled-form-float select')
      .forEach(($el) => fn.handleStyledBlur($el))

    fn.setupSpecialFields()
    fn.setupMasking()
  },

  handleLengthLimit: (e) => {
    const $input = e.target.closest('.has-length-limit')
    const $field = $input.closest('.field.has-length-limit')
    let count = $input.maxLength - $input.value.length

    if ($input && $field) {
      const $count = $field.querySelector('.length-limit-counter span')

      if (count <= 0) {
        count = 0
      }

      $count.textContent = `(${count}`
    }
  },

  handleStyledFocus: (e) => {
    const $wrapper = e.target.closest('.form-field-wrapper')

    if ($wrapper) {
      $wrapper.classList.add('is-focused')
    }
  },

  setupMasking: () => {
    const $zipInputs = document.querySelectorAll('input[name="Zip"]')
    const $telInputs = document.querySelectorAll('input[type="tel"]')
    $zipInputs.forEach(($input) => {
      let mask = IMask($input, {
        mask: Number,
        scale: 0,
        signed: false,
        thousandsSeparator: '',
        padFractionalZeros: false,
      })
      mask.updateOptions({ mask: Number })
    })
    $telInputs.forEach(($input) => {
      let mask = IMask($input, {
        mask: '(000) 000-0000',
      })
      mask.updateOptions({ mask: '(000) 000-0000' })
    })
  },

  handleStyledBlur: ($input) => {
    const $wrapper = $input.closest('.form-field-wrapper')

    if ($wrapper) {
      $wrapper.classList.remove('is-focused')

      if ($input.value === '') {
        $wrapper.classList.remove('is-filled')
      } else {
        $wrapper.classList.add('is-filled')
      }
    }
  },

  setupSpecialFields: () => {
    document.querySelectorAll('form').forEach(($form) => {
      // Setup file inputs
      $form.querySelectorAll('input[type=file]').forEach(($input) => {
        const $placeholder = document.createElement('div')
        $placeholder.classList.add('file-input-placeholder')

        if ($input.value) {
          $placeholder.textContent = $input.files[0].name
        } else {
          $placeholder.textContent = $input.dataset.placeholder
        }

        $input.parentNode.insertBefore($placeholder, $input)

        $placeholder.addEventListener('click', () => $input.click())

        $input.addEventListener('change', (e) => {
          $placeholder.textContent = e.target.files[0].name
          $placeholder.classList.add('filled')
        })
      })

      // Setup length limits
      $form
        .querySelectorAll('.form-field-wrapper.has-length-limit')
        .forEach(($field) => {
          const $input = $field.querySelector('.has-length-limit')

          if ($input && $input.maxLength) {
            const $label = $field.querySelector('label')
            $label.classList.add('has-length-limit')

            const $counter = document.createElement('div')
            $counter.classList.add('length-limit-counter')

            const $count = document.createElement('span')
            $count.textContent = `(${$input.maxLength - $input.value.length}`

            $counter.appendChild($count)
            $counter.appendChild(
              document.createTextNode(' characters remaining)')
            )

            const $labelHolder = document.createElement('div')

            $labelHolder.classList.add('form-field-label')
            $labelHolder.appendChild($label.cloneNode(true))
            $labelHolder.appendChild($counter)

            $label.replaceWith($labelHolder)
          }
        })
    })
  },

  handleAjax: (e) => {
    e.preventDefault()

    const $form = e.target
    const isValid = handleValidation($form)

    if (isValid) {
      const $formMessages = $form.querySelector('.form-messages')
      const $submitButton = $form.querySelector('[type=submit]')
      let autoHideMessage = true
      fn.toggleSubmit($submitButton)

      ajax
        .url($form.action)
        .body(new FormData($form))
        .post()
        .json((res) => {
          if (res.success) {
            $form.reset()
            $form
              .querySelectorAll('.is-focused')
              .forEach((x) => x.classList.remove('is-focused'))
            $form
              .querySelectorAll('.is-filled')
              .forEach((x) => x.classList.remove('is-filled'))
            $form.querySelectorAll('select').forEach((x) => (x.value = null))
            $form
              .querySelectorAll('.toggle-fields')
              .forEach((x) => x.classList.add('hidden'))

            if ($form.dataset.hideOnSubmit) {
              $form
                .querySelectorAll('.form-content')
                .forEach((x) => x.classList.add('hidden'))
              autoHideMessage = false

              if ($form.classList.contains('partners-form')) {
                document
                  .querySelector('.partners-form-trigger')
                  .classList.add('hidden')
              }
            }

            if ($form.dataset.formSuccessModal) {
              fn.handleFormSuccessModal($form.dataset.formSuccessModal)

              return
            }
          }

          if (res.message) {
            fn.showFormMessages(
              $formMessages,
              res.message,
              res.success,
              autoHideMessage
            )
          }
        })
        .catch(() => {
          fn.showFormMessages(
            $formMessages,
            'Sorry, there was a problem with your submission'
          )
        })
        .finally(() => {
          fn.toggleSubmit($submitButton)
        })
    }
  },

  toggleSubmit: ($submitButton) => {
    $submitButton.disabled = !$submitButton.disabled
    $submitButton.classList.toggle('btn-loading')
  },

  showFormMessages: ($holder, message, success, autoHide) => {
    $holder.style.display = 'block'
    $holder.innerHTML = message

    if (success) {
      $holder.classList.remove('form-message-error')
    } else {
      $holder.classList.add('form-message-error')
    }

    if (autoHide) {
      setTimeout(() => {
        $holder.style.display = 'none'
      }, 5000)
    }
  },

  handleFormSuccessModal: (url) => {
    const modal = new tingle.modal({
      closeMethods: ['button'],
      cssClass: ['modal', 'modal--content'],
      beforeOpen: () => {
        // Move the close button
        const $closeBtn = modal.modal.querySelector('.tingle-modal__close')
        modal.modal.querySelector('.tingle-modal-box').appendChild($closeBtn)
      },
      onClose: () => {
        modal.destroy()
      },
    })

    ajax
      .url(url)
      .get()
      .text((resp) => {
        modal.setContent(resp)
      })

    window._currentModal = modal

    modal.open()
  },
}

export default {
  can: () => document.querySelectorAll('form:not(.multistepform)').length,
  run: fn.init,
}
